module.exports = __webpack_public_path__ + "img/anhui.5a9f9e6e.jpg";